import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CoreService } from '../services/core.service';
import { ParamsMedia, MediaQueovalModel, MediaExtranetModel, MediaModel, FilterMedia, eAppContext, ConfigKey, FileModel } from '../models';
import { Observable } from 'rxjs';
import { HttpService } from './dataAccess.service';
import * as fileSaver from 'file-saver';
import { b64EncodeUnicode } from '../utilities';

@Injectable({
  providedIn: 'root'
})

export class MediaService {

  constructor(
    private http: HttpService,
    private indParam: CoreService,
    private httpclient: HttpClient
  ) { }

  /**
   * @description Récupération du média (retourne la destination)
   * @param MediaName nom du média avec son extension
   */
  public getMedia(MediaName: string): Observable<MediaQueovalModel> | Observable<MediaExtranetModel> {
    switch (this.indParam.Context) {
      case eAppContext.QUEOVAL:
        return this.http.getHttp<MediaQueovalModel>(`${this.getStreamHttp()}api/MediaQueoval/GET_MEDIA/${MediaName}/`);
      default:
        return this.http.getHttp<MediaExtranetModel>(`${this.getStreamHttp()}api/MediaExtranet/GET_MEDIA/${MediaName}/`);
    }
  }

  /**
   * @description Récupération des médias (retourne la destination)
   * @param MediaNames nom des médias avec leurs extensions séparés par triple Pipe '|||' (retourne la destination)
   * @returns Array<{string FullName; string Name; string Path; bool Exist;}>
   * @example 'preview01.jpg|video01.mp4'
   */
  public getMultipleMedia(MediaNames: string | Array<string>): Observable<MediaQueovalModel> | Observable<MediaExtranetModel> {
    if (typeof MediaNames === 'string') {
      MediaNames = MediaNames.split('|||');
    }

    const model: MediaModel = new MediaModel();
    model.ListMediaNames = MediaNames;

    switch (this.indParam.Context) {
      case eAppContext.QUEOVAL:
        const QueovalModel: MediaQueovalModel = new MediaQueovalModel;
        QueovalModel.Mode = 'GET_MULTIPLE_MEDIA';
        QueovalModel.MediaModel = model;
        return this.http.postHttp<MediaQueovalModel>(`${this.getStreamHttp()}api/MediaQueoval/`, QueovalModel);
      default:
        const ExtranetModel: MediaExtranetModel = new MediaExtranetModel;
        ExtranetModel.Mode = 'GET_MULTIPLE_MEDIA';
        ExtranetModel.MediaModel = model;
        return this.http.postHttp<MediaExtranetModel>(`${this.getStreamHttp()}api/MediaExtranet/`, ExtranetModel);
    }
  }

  /**
   * @description Récupération de tout les médias du client par type (stream api)
   * @param typeMedias liste des types désirés séparés par un |
   *  VIDEO|IMG|AUDIO|DOC ou ALL
   *  @example 'VIDEO', 'IMG|VIDEO', 'DOC|VIDEO|AUDIO', 'ALL'
   */
  public getAllMediasClient(typeMedias: string = 'ALL'): Observable<MediaQueovalModel> | Observable<MediaExtranetModel> {
    return this.indParam.Context === eAppContext.QUEOVAL
      ? this.http.getHttp<MediaQueovalModel>(`${this.getStreamHttp()}api/MediaQueoval/GET_ALL_MEDIAS_CLIENT/${typeMedias}/`)
      : this.http.getHttp<MediaExtranetModel>(`${this.getStreamHttp()}api/MediaExtranet/GET_ALL_MEDIAS_CLIENT/${typeMedias}/`);
  }

  /**
   * @description supprime le média indiqué
   * @param nameMedia nom du média
   * @param type types génériques VIDEO, IMG, AUDIO, DOC, PREVIEW
   * types avancés IMG/jpg, IMG/jpeg, IMG/png
   * sert à déterminer dans quel dossier se trouve le média à supprimer
   * @example deleteMedia('video01.mp4', 'VIDEO')
   */
  public deleteMedia(nameMedias: string | Array<string>, type: string): Observable<MediaQueovalModel> | Observable<MediaExtranetModel> {

    const model: MediaModel = new MediaModel;
    model.ListMedia = new Array<ParamsMedia>();
    if (Array.isArray(nameMedias)) {
      for (const name of nameMedias) {
        const media: ParamsMedia = new ParamsMedia;
        media.FullName = name;
        media.Type = type;
        model.ListMedia.push(media);
      }
    } else {
      const media: ParamsMedia = new ParamsMedia;
      media.FullName = nameMedias;
      media.Type = type;
      model.ListMedia.push(media);
    }
    switch (this.indParam.Context) {
      case eAppContext.QUEOVAL:
        const QueovalModel: MediaQueovalModel = new MediaQueovalModel;
        QueovalModel.Mode = 'DELETE_MEDIA';
        QueovalModel.MediaModel = model;
        return this.http.postHttp<MediaQueovalModel>(`${this.getStreamHttp()}api/MediaQueoval/`, QueovalModel);
      default:
        const ExtranetModel: MediaExtranetModel = new MediaExtranetModel;
        ExtranetModel.Mode = 'DELETE_MEDIA';
        ExtranetModel.MediaModel = model;
        return this.http.postHttp<MediaExtranetModel>(`${this.getStreamHttp()}api/MediaExtranet/`, ExtranetModel);
    }
  }

  /**
   * @description créer automatiquement le nombre de préviews indiquées pour un média donné (autoPreviews)
   * @param nameMedia nom du média
   * @param numberPreviewsToCreate nombre de miniatures à créer
   * @param media OPTIONNEL: récupèreles données déjà remplies d'un hypothétique média déjà existant, sinon créé un new ParamsMedia
   * @example CreatePreview('video01.mp4', 4)
   */
  public CreatePreview(nameMedia: string, numberPreviewsToCreate: number, media = new ParamsMedia): Observable<MediaQueovalModel> | Observable<MediaExtranetModel> {
    const model: MediaModel = new MediaModel;
    model.Media = media;
    model.Media.FullName = nameMedia;
    model.Media.NumberAutoPreviews = numberPreviewsToCreate;
    localStorage.setItem('configFile', `${this.indParam.getConfigKey(ConfigKey.STREAM_URL) ? this.indParam.getConfigKey(ConfigKey.STREAM_URL) : this.indParam.getConfigKey(ConfigKey.STREAM_HTTP)}`);
    switch (this.indParam.Context) {
      case eAppContext.QUEOVAL:
        const QueovalModel: MediaQueovalModel = new MediaQueovalModel;
        QueovalModel.Mode = 'CREATE_PREVIEW';
        QueovalModel.MediaModel = model;
        return this.http.postHttp<MediaQueovalModel>(`${this.getStreamHttp()}api/MediaQueoval/`, QueovalModel);
      default:
        const ExtranetModel: MediaExtranetModel = new MediaExtranetModel;
        ExtranetModel.Mode = 'CREATE_PREVIEW';
        ExtranetModel.MediaModel = model;
        return this.http.postHttp<MediaExtranetModel>(`${this.getStreamHttp()}api/MediaExtranet/`, ExtranetModel);
    }
  }

  /**
   * @description upload un média
   * @param file fichier à uploader
   * @param type types génériques VIDEO, IMG, AUDIO, DOC
   * sert à déterminer dans quel dossier se trouve le média à uploader
   * @param currentValue paramètre obsionel pour le BODISPLAY
   * @example uploadMedia(videoFile, 'VIDEO')
   */
  public uploadMedia(file: File, type: string, currentValue?: string): any {
    localStorage.setItem('httpPath', '');
    const config: any = {
      responseType: 'arraybuffer' as 'arraybuffer',
      observe: 'response'
    };
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('mode', type);
    formData.append('token', this.indParam.AppParams.token);
    if (currentValue) {
      formData.append('currentValue', currentValue);
    }
    let result: any = null;
    switch (this.indParam.Context) {
      case eAppContext.QUEOVAL:
        result = this.httpclient.post(`${this.getStreamHttp()}api/StreamUploadQueoval/`, formData, config);
        break;
      default:
        result = this.httpclient.post(`${this.getStreamHttp()}api/StreamUpload/`, formData, config);
        break;
    }
    const configFile: string = !this.indParam.getConfigKey(ConfigKey.STREAM_URL) || type === 'BODISPLAY' || type === 'LOGO' ? this.indParam.getConfigKey(ConfigKey.STREAM_HTTP) : this.indParam.getConfigKey(ConfigKey.STREAM_URL);
    localStorage.setItem('configFile', `${configFile}`);
    return result;
  }

  /**
   * @description upload une préview rattachée à un média (personnalPreview)
   * @param file fichier de la miniature (image) à uploader
   * @param attachedFileName nom du média auquel il est rattaché
   * @example uploadPreview(previewFile, 'videoName.mp3')
   */
  public uploadPreview(file: File, attachedFileName: string): any {
    localStorage.setItem('httpPath', '');
    const config: any = {
      responseType: 'arraybuffer' as 'arraybuffer'
    };
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('mode', 'PREVIEW');
    formData.append('token', this.indParam.AppParams.token);
    formData.append('attachedFileName', attachedFileName);
    let result: any = null;
    switch (this.indParam.Context) {
      case eAppContext.QUEOVAL:
        result = this.httpclient.post(`${this.getStreamHttp()}api/StreamUploadQueoval`, formData, config);
        break;
      default:
        result = this.httpclient.post(`${this.getStreamHttp()}api/StreamUpload`, formData, config);
        break;
    }
    localStorage.setItem('configFile', `${this.indParam.getConfigKey(ConfigKey.STREAM_URL) ? this.indParam.getConfigKey(ConfigKey.STREAM_URL) : this.indParam.getConfigKey(ConfigKey.STREAM_HTTP)}`);
    return result;
  }

  public RenameMediasOnStream(ListMedias: Array<ParamsMedia>): Observable<MediaQueovalModel> | Observable<MediaExtranetModel> {
    const model: MediaModel = new MediaModel;
    model.ListMedia = ListMedias;
    switch (this.indParam.Context) {
      case eAppContext.QUEOVAL:
        const QueovalModel: MediaQueovalModel = new MediaQueovalModel;
        QueovalModel.Mode = 'RENAME_MEDIAS';
        QueovalModel.MediaModel = model;
        return this.http.postHttp<MediaQueovalModel>(`${this.getStreamHttp()}api/MediaQueoval/`, QueovalModel);
      default:
        const ExtranetModel: MediaExtranetModel = new MediaExtranetModel;
        ExtranetModel.Mode = 'RENAME_MEDIAS';
        ExtranetModel.MediaModel = model;
        return this.http.postHttp<MediaExtranetModel>(`${this.getStreamHttp()}api/MediaExtranet/`, ExtranetModel);
    }

  }
  public getMediaSizes(): Observable<MediaQueovalModel> {
    return this.http.getHttp<MediaQueovalModel>(`${this.indParam.AppParams.apiUrl}api/media/GET_MAX_MEDIAS_SIZES/0/`);
  }
  /**
   * @description sauvegarde un media en base de données
   * @param media média a sauvegarder
   */
  public SaveMediaBo(media: ParamsMedia): Observable<MediaQueovalModel> {
    const model: MediaQueovalModel = new MediaQueovalModel;
    model.MediaModel.Media = media;
    model.Mode = 'SAVE_MEDIA';
    return this.http.postHttp<MediaQueovalModel>(`${this.indParam.AppParams.apiUrl}api/media`, model);
  }

  public SaveListMediaBo(ListMedias: Array<ParamsMedia>): Observable<MediaQueovalModel> {
    const model: MediaQueovalModel = new MediaQueovalModel;
    model.MediaModel.ListMedia = ListMedias;
    model.Mode = 'SAVE_MULLTIPLES_MEDIAS';
    return this.http.postHttp<MediaQueovalModel>(`${this.indParam.AppParams.apiUrl}api/media`, model);
  }

  public DeleteMediaBo(media: ParamsMedia): Observable<MediaQueovalModel> {
    const model: MediaQueovalModel = new MediaQueovalModel;
    model.MediaModel.Media = media;
    model.Mode = 'DELETE_MEDIA';
    return this.http.postHttp<MediaQueovalModel>(`${this.indParam.AppParams.apiUrl}api/media`, model);
  }

  public UpdateMultipleMediaBo(medias: Array<ParamsMedia>): Observable<MediaQueovalModel> {
    const model: MediaQueovalModel = new MediaQueovalModel;
    model.MediaModel.ListMedia = medias;
    model.Mode = 'UPDATE_MULTIPLE_MEDIA';
    return this.http.postHttp<MediaQueovalModel>(`${this.indParam.AppParams.apiUrl}api/media`, model);
  }

  public UpdateMediaBo(media: ParamsMedia): Observable<MediaQueovalModel> {
    const model: MediaQueovalModel = new MediaQueovalModel;
    model.MediaModel.Media = media;
    model.Mode = 'UPDATE_MEDIA';
    return this.http.postHttp<MediaQueovalModel>(`${this.indParam.AppParams.apiUrl}api/media`, model);
  }

  /**
   * @param filter string: ident du media ou FilterMedia pour une liste filtée
   */
  public GetMediasFromBo(filter: FilterMedia | string = new FilterMedia): Observable<MediaQueovalModel> {
    const model: MediaQueovalModel = new MediaQueovalModel;
    if (typeof filter === 'string') {
      model.MediaModel.Filter = new FilterMedia;
      model.MediaModel.Filter.byName = filter;
    } else {
      model.MediaModel.Filter = filter;
    }
    model.Mode = 'GET_MEDIAS';
    return this.http.postHttp<MediaQueovalModel>(`${this.indParam.AppParams.apiUrl}api/media/`, model);
  }

  public GetMediaEstore(fileName: string, authorKey: string): Observable<MediaQueovalModel> {
    const prm: string = b64EncodeUnicode(`${fileName}|${authorKey}`);
    return this.http.getHttp<MediaQueovalModel>(`${this.indParam.AppParams.apiUrl}api/media/GET_MEDIA_ESTORE/${prm}`);
  }

  public UpdateStoringServer(newServerName: string = '', listMediaIds: Array<number> = []): Observable<MediaQueovalModel> {

    newServerName = newServerName === '' ? this.getStreamHttp() : newServerName;

    const model: MediaQueovalModel = new MediaQueovalModel;
    model.MediaModel.ServerName = newServerName;
    model.MediaModel.ListMediaIds = listMediaIds;

    model.Mode = 'UPDATE_STORING_SERVER';
    return this.http.postHttp<MediaQueovalModel>(`${this.indParam.AppParams.apiUrl}api/media`, model);
  }

  // ----------------- DOWNLOAD FILE -----------------
  /**
   * Téléchargement d'un fichier
   * @param idDoc Ident du document (ou nom du fichier)
   */
  downloadFile(fileModel: FileModel): void {
    this.indParam.showSplash(true);
    // tslint:disable-next-line:radix
    fileModel.Name = (fileModel.Name.indexOf('.') === -1 && !isNaN(parseInt(fileModel.Name))) ? `${fileModel.Name}.pdf` : fileModel.Name;


    this.download(fileModel).subscribe((response: any) => {

      // code modifié (avec response -> arraybuffer) ---------------------------------------------------------
      let fileType: string = '';
      switch (fileModel.Name.split('.').pop()) {
        case 'pdf': fileType = 'application/pdf'; break;
        case 'jpg': fileType = 'image/jpg'; break;
        case 'jpeg': fileType = 'image/jpeg'; break;
        case 'png': fileType = 'image/png'; break;
        case 'gif': fileType = 'image/gif'; break;
        case 'xml': fileType = 'application/xml'; break;
        case 'txt': fileType = 'text/plain'; break;
        case 'doc': fileType = 'application/vnd.ms-word'; break;
        case 'docx': fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; break;
        case 'xls': fileType = 'application/vnd.ms-excel'; break;
        case 'xlsx': fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; break;
        case 'bmp': fileType = 'image/bmp'; break;
        case 'wav': fileType = 'audio/wav'; break;
        case 'ppt': fileType = 'application/vnd.ms-powerpoint'; break;
        case 'pptx': fileType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'; break;
        case 'dwg': fileType = 'image/vnd.dwg'; break;
        case 'zip': fileType = 'octet/stream'; break;
      }
      const blob: Blob = new Blob([(response)], {
        type: fileType,
      });

      if (blob.size > 0) {
        if (window.navigator && (window.navigator.msSaveOrOpenBlob !== undefined || window.navigator.msSaveOrOpenBlob !== null) && fileType !== 'application/pdf') {
          fileSaver.saveAs(blob, fileModel.Name);
        } else {
          // Pour le PDF on l'ouvre dans une nouvelle fenêtre
          const objectUrl: string = URL.createObjectURL(blob);
          window.open(objectUrl);
        }

      }
      this.indParam.showSplash(false);

      // --------------------------------------------------------------------------------
    }, (error: any) => {
      console.error((error) ? this.indParam.getTrad('Error_EL') : `${this.indParam.getTrad('undeferron_EL')} core.service.ts`);
        this.indParam.showSplash(false);
    });
  }

  /**
   * Appel serveur pour le téléchargement
   * @param fileName Nom du fichier à télécharger
   */
  private download(fileModel: FileModel): Observable<any> {
    const data: any = { QueovalOriginalName: fileModel.Name, FilePath: fileModel.FullPath };
    const config: any = { responseType: 'arraybuffer' as 'arraybuffer' };
    // Download from streamService
    return this.httpclient.post(`${this.indParam.getConfigKey(ConfigKey.STREAM_HTTP)}api/StreamDownload`, data, config);
  }

  private getStreamHttp(): string {
    return this.indParam.getConfigKey(ConfigKey.STREAM_HTTP);
  }
}
